import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export default defineNuxtPlugin(() => {
  const appConfig = useAppConfig()

  let appInsights: ApplicationInsights | null = null
  let shouldBlockTelemetry = () => false

  function initAppInsights() {
    if (appInsights || !appConfig.APP_INSIGHTS_CONNECTION_STRING) {
      return
    }

    appInsights = new ApplicationInsights({
      config: {
        connectionString: appConfig.APP_INSIGHTS_CONNECTION_STRING as string,
        // Chrome blocks the legacy unload event through Permissions Policy.
        // Application Insights still flushes through pagehide and visibilitychange.
        disablePageUnloadEvents: ['unload'],
      },
    })

    appInsights.loadAppInsights()
    appInsights.addTelemetryInitializer(() => {
      if (shouldBlockTelemetry()) {
        return false
      }
    })
  }

  function trackPageView() {
    initAppInsights()
    if (!appInsights) {
      return
    }

    appInsights.trackPageView({
      name: document.title,
      uri: window.location.href,
    })
  }

  const telemetry = useProjectTelemetryPageTracking({
    activate: initAppInsights,
    trackPageView,
  })

  shouldBlockTelemetry = telemetry.shouldBlockTelemetry
})
